import React, {  useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './CondoCorporationComponent.metadata.json5';
import styles from "../DirectorsAndOfficers.module.scss";

function CondoCorporationComponent(props) {

const { submissionVM, updateWizardData,pathUpdated,onValidate} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate: setComponentValidation, isComponentValid } = useValidation('CondoCorporationComponent');
const modelVM = _.get(submissionVM, pathUpdated)

modelVM.value.isValidationReq = true

useEffect(() =>{
    if (onValidate) {
        onValidate(isComponentValid,'CondoCorporationComponent');
    }
},[isComponentValid, onValidate])

const doeStrFolProGuiOnCon7IsRequired = useCallback(() =>{
    if((_.get(submissionVM, 'baseData.baseState_Ext.value.code', '') === 'BC' || _.get(modelVM, 'baseData.baseState_Ext.value.code', '') === 'ON')) {
        return true;
    }

    return false;
},[modelVM, submissionVM])

const calTotalNumOfUnits = useCallback(() =>{
      const numofResUnit = _.get(modelVM, 'numOfResUni3.value') !== null ? _.get(modelVM, 'numOfResUni3.value'): 0
      const numofComUnit = _.get(modelVM, 'numOfComUni4.value') !== null ? _.get(modelVM, 'numOfComUni4.value'): 0
      const totalNumofUnits = numofResUnit + numofComUnit
  
      _.set(modelVM, 'totalNumOfUnits_Ext.value', totalNumofUnits) 
   },[modelVM]);
// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        doeStrFolProGuiOnCon7: {
            visible: _.get(submissionVM, 'baseData.baseState_Ext.value.code', '') === 'BC' || _.get(submissionVM, 'baseData.baseState_Ext.value.code', '') === 'ON',
            required: doeStrFolProGuiOnCon7IsRequired(),
            showRequired: doeStrFolProGuiOnCon7IsRequired(),
        },
        maiFunBal9: {
            visible: _.get(modelVM, 'isTheAMaiFun8.value', false)
        },
        repFunBal13: {
            visible: _.get(modelVM, 'isTheARepFun12.value', false)
        },
        namOfManCom15: {
            visible: _.get(modelVM, 'isTheStrConManByAn14.value', false)
        },
        doeTheManComHavProLia16: {
            visible: _.get(modelVM, 'isTheStrConManByAn14.value', false)
        },
        conFunBal11: {
            visible: _.get(modelVM, 'isTheAConFun10.value', true)
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            if(changedPath === 'numOfResUni3' || changedPath === 'numOfComUni4') {
                calTotalNumOfUnits()
            }

            updateWizardData(submissionVM);         
        },
        [calTotalNumOfUnits, pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={setComponentValidation}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

CondoCorporationComponent.propTypes = wizardProps;
export default withRouter(CondoCorporationComponent);
